import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportAttachmentController::download
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportAttachmentController.php:20
* @route 'https://org.proexpert.app/org/support/attachments/{attachment}'
*/
export const download = (args: { attachment: string | number } | [attachment: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

download.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/support/attachments/{attachment}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportAttachmentController::download
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportAttachmentController.php:20
* @route 'https://org.proexpert.app/org/support/attachments/{attachment}'
*/
download.url = (args: { attachment: string | number } | [attachment: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { attachment: args }
    }

    if (Array.isArray(args)) {
        args = {
            attachment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        attachment: args.attachment,
    }

    return download.definition.url
            .replace('{attachment}', parsedArgs.attachment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportAttachmentController::download
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportAttachmentController.php:20
* @route 'https://org.proexpert.app/org/support/attachments/{attachment}'
*/
download.get = (args: { attachment: string | number } | [attachment: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportAttachmentController::download
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportAttachmentController.php:20
* @route 'https://org.proexpert.app/org/support/attachments/{attachment}'
*/
download.head = (args: { attachment: string | number } | [attachment: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: download.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportAttachmentController::download
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportAttachmentController.php:20
* @route 'https://org.proexpert.app/org/support/attachments/{attachment}'
*/
const downloadForm = (args: { attachment: string | number } | [attachment: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportAttachmentController::download
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportAttachmentController.php:20
* @route 'https://org.proexpert.app/org/support/attachments/{attachment}'
*/
downloadForm.get = (args: { attachment: string | number } | [attachment: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Support\Presentation\Http\Controllers\OrgSupportAttachmentController::download
* @see app/Domain/Support/Presentation/Http/Controllers/OrgSupportAttachmentController.php:20
* @route 'https://org.proexpert.app/org/support/attachments/{attachment}'
*/
downloadForm.head = (args: { attachment: string | number } | [attachment: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

download.form = downloadForm

const attachments = {
    download: Object.assign(download, download),
}

export default attachments